import { createFileRoute } from "@tanstack/react-router"

import { requirePermission } from "@/lib/route-guards"
import { Perm } from "@/lib/permissions"
import { InteriorPackageEditorPage } from "@/pages/interior-packages/interior-package-editor-page"

export const Route = createFileRoute("/_authenticated/interior-packages/$id")({
	beforeLoad: async ({ context }) => {
		await requirePermission(context, Perm.PROJECT_READ, { to: "/settings/interior-packages" })
	},
	component: InteriorPackageEditorPage,
})
